import ReactOnRails from 'react-on-rails';

import Shop from 'pages/shop';
import Footer from 'components/Footer';

ReactOnRails.register({
  Shop,
  Footer,
});
